module.exports = __webpack_public_path__ + "media/src/images/delivery-icon8-ba37b25248fd4f010b3b5fc0b3b3edf7.png";